import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
/**
 * Componente para exibicao de mensagem de servico indisponivel
 * Exibido quando o endpoint EN4 esta indisponivel
 */
var ServiceUnavailableComponent = /** @class */ (function () {
    function ServiceUnavailableComponent(router, translateService) {
        this.router = router;
        this.translateService = translateService;
    }
    /**
     * Tenta recarregar a pagina
     */
    ServiceUnavailableComponent.prototype.retry = function () {
        window.location.reload();
    };
    /**
     * Navega para a pagina inicial
     */
    ServiceUnavailableComponent.prototype.goHome = function () {
        this.router.navigate(['/']);
    };
    return ServiceUnavailableComponent;
}());
export { ServiceUnavailableComponent };
